import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { EstablishmentDetailService } from './establishmentdetail.service';
import { global } from '../../shared/global';
declare var $: any;

@Component({
  selector: 'app-establishmentdetail',
  templateUrl: './establishmentdetail.component.html',
  styleUrls: ['./establishmentdetail.component.css']
})
export class EstablishmentdetailComponent implements OnInit {
  searchtext;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  HashCode: any;
  establishmentDetailList: any;
  doc: any;
  fileextension: any;
  schoolname:any;
  maxDate:any;

  constructor(private service: EstablishmentDetailService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.HashCode = this.rout.snapshot.paramMap.get('ID');
      this.schoolname ="- ("+ localStorage.getItem("SchoolName") +")";
      if (this.HashCode.trim() == "") {
        this.router.navigate(['/registrationlist']);
        return;
      }
    } else {
      this.router.navigate(['/registrationlist']);
      return;
    }
    var dtToday = new Date();
    var month: string = (dtToday.getMonth() + 1).toString();
    var day: string = (dtToday.getDate()).toString();
    var year: string = (dtToday.getFullYear()).toString();
    if (parseInt(month) < 10)
      month = '0' + month.toString();
    if (parseInt(day) < 10)
      day = '0' + day.toString();
    this.maxDate = year + '-' + month + '-' + day;
    
    this.getEstablishmentDetailList();
  }
  getEstablishmentDetailList() {
    const data = {
      HashCode: this.HashCode
    };
    this.spinner.show();
    this.service.getEstablishmentDetailList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.establishmentDetailList = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.establishmentDetailList = this.responseData.establishmentDetail;
          setTimeout(() => {
            for(var i=0;i<this.establishmentDetailList.length;i++){
              $('#ExpenseDate'+i).attr('max', this.maxDate);
              $('#ExpenseDate'+i).val(this.establishmentDetailList[i]["EstablishmentDate"]);
              if (this.establishmentDetailList[i]["Extension"] == ".pdf") {
                document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
              }
            }
            }, 1000);
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  uploadImage(event, i) {
    if (event.target.files.length > 0) {
      this.doc = event.target.files[0];
      if (Math.round(this.doc.size / 1024) > 1000) {
        this.toastr.error("File size can't be greater then 1 MB");
        return;
      }
      this.fileextension = this.doc.name.split('.');
      if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "png"
        && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpeg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "pdf") {
        this.toastr.error("You can upload only jpg, jpeg, png or pdf file");
        return;
      }
      if (this.fileextension[this.fileextension.length - 1] == "pdf") {
        document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
      }
      //else {
        const [file] = event.target.files;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          document.getElementById("preview_" + i).setAttribute("src", reader.result as string);
          if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() == "pdf") {
            document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
          }
          this.establishmentDetailList[i]["Document"] = reader.result as string;
          //this.establishmentDetailList[i]["ViewURL"] = reader.result as string;
            this.establishmentDetailList[i]["Extension"] = "." + this.fileextension[this.fileextension.length - 1].toString().toLowerCase();
        //}
      }
    } else {
      this.doc = "";
      this.establishmentDetailList[i]["Document"] = "";
      this.establishmentDetailList[i]["ViewURL"] = "/assets/images/no-image.jpg";
      this.establishmentDetailList[i]["Extension"] = "";
    }
  }
  setdate(i) {
    this.establishmentDetailList[i]["EstablishmentDate"] = $("#ExpenseDate" + i).val();
  }
  saveDetail() {
    for (var i = 0; i < this.establishmentDetailList.length; i++) {
      if (this.establishmentDetailList[i]["EstablishmentDate"] != "" &&
        (this.establishmentDetailList[i]["Document"] == "" && this.establishmentDetailList[i]["Document"] != "/assets/images/no-image.jpg")) {
        this.toastr.error("Document is compulsory while adding date");
        return;
      }
      if ((this.establishmentDetailList[i]["Document"] != "" && this.establishmentDetailList[i]["Document"] != "/assets/images/no-image.jpg") &&
        this.establishmentDetailList[i]["EstablishmentDate"] == "") {
        this.toastr.error("Date is compulsory while adding document");
        return;
      }
    }
    const data = {
      HashCode: this.HashCode,
      establishmentDetail: this.establishmentDetailList
    };
    this.spinner.show();
    this.service.saveEstablishmentDetail(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.toastr.success(this.responseData.message);
          this.getEstablishmentDetailList();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  deleteEstablishmentDetail(HashCode,filePath){
    var a = confirm("Are you sure you want to delete");
    if (a) {
      const data = {
        HashCode: HashCode,
        FilePath: filePath
      };
      this.spinner.show();
      this.service.deleteEstablishmentDetail(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getEstablishmentDetailList();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.establishmentDetailList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  Cancel(){
    this.router.navigate(['/registrationlist']);
  }
}
